import React from "react";

interface PageStateProps {
  text: string;
  tone?: "default" | "error";
  children?: React.ReactNode;
}

export function PageState({
  text,
  tone = "default",
  children,
}: PageStateProps) {
  return (
    <div
      className={`space-y-6 p-12 ${tone === "error" ? "text-destructive" : ""}`}
    >
      <div>{text}</div>
      {children}
    </div>
  );
}
